/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisibilitySearchAppearanceDto } from '../../models/visibility-search-appearance-dto';

export interface GetVisibilitySearchAppearances$Params {
}

export function getVisibilitySearchAppearances(http: HttpClient, rootUrl: string, params?: GetVisibilitySearchAppearances$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VisibilitySearchAppearanceDto>>> {
  const rb = new RequestBuilder(rootUrl, getVisibilitySearchAppearances.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VisibilitySearchAppearanceDto>>;
    })
  );
}

getVisibilitySearchAppearances.PATH = '/api/company/visibility/search-appearances';
